/*
 * The Name step of the Tour Wizard
 */

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

const NameInput = styled.input`
  font-size: 17px;
  border: 1px solid ${Theme.colors.borderActionableFieldColor};
  color: ${Theme.colors.primaryTextColor};
  padding: 10px;
  text-align: left;
  display: block;
  width: 100%;
  -webkit-appearance: none;
  border-radius: 0;
  &::placeholder {
    color: ${Theme.colors.guideTextColor};
  }
`;

const InputLimit = styled.div`
  font-size: 13px;
  color: ${Theme.colors.guideTextColor};
  float: right;
  padding-top: 5px;
`;

export const TourName = ({ onChangeCallback, savedValues }) => {
  const { name } = savedValues;

  const handleOnChange = (name) => (e) => {
    const value = e.target.value;
    onChangeCallback(name, value);
  };

  return (
    <div className="TourWizard TourWizard-Name">
      <div className="TourWizard-Input">
        <NameInput
          value={name}
          data-testid="input-name"
          onChange={handleOnChange('name')}
          maxLength={75}
          placeholder="Enter a name"
        />
        <InputLimit>75 Character limit</InputLimit>
      </div>
    </div>
  );
};
